<template>
  <div style="position: relative">
    <el-form
      :model="state.model"
      ref="formDom"
      style="width: 100%; padding: 0 20px"
      size="normal"
    >
      <div
        style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 10px"
      >
        <el-form-item label="结算总额">
          {{ state.model.total_money || "0.00" }}
        </el-form-item>
        <el-form-item label="已收款">
          {{ state.model.collected_money || "0.00" }}
        </el-form-item>
        <el-form-item label="已申请金额">
          {{ state.model.applied_money || "0.00" }}
        </el-form-item>
        <el-form-item label="申请发放总额">
          {{ state.model.money || "0.00" }}
          <el-tag
            type="danger"
            effect="dark"
            round
            size="small"
            style="margin-left: 10px"
            v-if="state.model.is_arrearage === 1"
            >欠款发放
          </el-tag>
        </el-form-item>
        <el-form-item label="申请发放人数">
          {{ state.model.employee_num || "0" }}
        </el-form-item>
        <el-form-item
          label="经办人"
          prop="printer_id"
          :rules="[
            {
              required: true,
              message: '请选择客服专员',
              trigger: 'blur',
            },
          ]"
        >
          <el-tree-select
            v-model="state.model.printer_id"
            :props="{
              value: 'id',
              label: 'name',
              class: 'belonger-tree-class',
            }"
            placeholder="经办人"
            :data="state.admin_data"
            default-expand-all
            filterable
            clearable
            @current-change="
              (item) => {
                state.model.printer_department_id = item.pid;
              }
            "
          >
            <template #default="{ data }">
              <el-icon :size="16" v-if="data.type == 0"><UserFilled /></el-icon>
              <el-icon :size="16" v-else><User /></el-icon>
              <span style="margin-left: 3px">{{ data.name }}</span>
            </template>
          </el-tree-select>
        </el-form-item>
        <el-form-item
          label="项目编码"
          prop="project_no"
          :rules="[
            { required: true, message: '请输入项目编码', trigger: 'blur' },
          ]"
        >
          <el-input v-model="state.model.project_no"></el-input>
        </el-form-item>
        <el-form-item
          label="约定发薪日期"
          prop="pay_date"
          :rules="[
            { required: true, message: '请选择约定发薪日期', trigger: 'blur' },
          ]"
        >
          <el-date-picker
            v-model="state.model.pay_date"
            type="date"
            placeholder="约定发薪日期"
            value-format="YYYY-MM-DD"
            style="width: 100%"
          />
        </el-form-item>
        <div>
          <el-form-item
            label="收款账户信息"
            :rules="[
              {
                required: true,
                message: '请选择收款账户信息',
                trigger: 'blur',
              },
            ]"
            v-if="state.model.withholding_agent_type === 1"
          >
            <el-select
              v-model="state.opening_bank_id"
              placeholder="--收款账户信息--"
              value-key="id"
              @change="onUnitChange"
              popper-class="payroll-pay-unit-select"
            >
              <el-option
                v-for="item in state.settleunit_data"
                :key="item"
                :label="item.name"
                :value="item"
              >
                <div>
                  <span>
                    {{ item.name
                    }}<text
                      v-if="item.bank_account"
                      style="font-size: 90%; color: #999"
                      >{{ "/" + item.bank_account }}</text
                    >
                  </span>
                  <ul style="color: #999; font-size: 90%">
                    {{
                      item.opening_bank
                    }}
                  </ul>
                </div>
              </el-option>
              <template #footer>
                <el-button size="small" @click="onLoadAdmin()">刷新</el-button>
              </template>
            </el-select>
          </el-form-item>
        </div>
        <div
          style="
            grid-column: span 3;
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 10px;
          "
          v-if="state.model.withholding_agent_type === 1"
        >
          <el-form-item
            label="开户银行"
            prop="opening_bank"
            :rules="[
              { required: true, message: '请输入开户银行', trigger: 'blur' },
            ]"
          >
            <el-input v-model="state.model.opening_bank" clearable></el-input>
          </el-form-item>
          <el-form-item
            label="银行账户"
            prop="bank_account_name"
            :rules="[
              { required: true, message: '请输入银行账户', trigger: 'blur' },
            ]"
          >
            <el-input
              v-model="state.model.bank_account_name"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item
            label="银行账号"
            prop="bank_account"
            :rules="[
              { required: true, message: '请输入银行账号', trigger: 'blur' },
            ]"
          >
            <el-input v-model="state.model.bank_account" clearable></el-input>
          </el-form-item>
        </div>
        <el-form-item
          label="业务审核人"
          prop="operator_id"
          :rules="[
            { required: true, message: '请选择业务审核人', trigger: 'blur' },
          ]"
        >
          <el-select
            v-model="state.model.operator_id"
            placeholder="--业务审核人--"
          >
            <el-option
              v-for="item in state.model?.check_admin_list?.operator"
              :key="item.id"
              :label="
                (item.department_name ? '(' + item.department_name + ')' : '') +
                item.name
              "
              :value="item.id"
            />
            <template #footer>
              <el-button size="small" @click="onLoadAdmin()">刷新</el-button>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item
          label="财务审核人"
          prop="financial_id"
          :rules="[
            { required: true, message: '请选择财务审核人', trigger: 'blur' },
          ]"
        >
          <el-select
            v-model="state.model.financial_id"
            placeholder="--财务审核人--"
          >
            <el-option
              v-for="item in state.model?.check_admin_list?.financial"
              :key="item.id"
              :label="
                (item.department_name ? '(' + item.department_name + ')' : '') +
                item.name
              "
              :value="item.id"
            />
            <template #footer>
              <el-button size="small" @click="onLoadAdmin()">刷新</el-button>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item
          label="总经理审核"
          prop="manager_id"
          :rules="[
            { required: true, message: '请选择总经理', trigger: 'blur' },
          ]"
          v-if="state.model.is_arrearage === 1"
        >
          <el-select v-model="state.model.manager_id" placeholder="--总经理--">
            <el-option
              v-for="item in state.model?.check_admin_list?.manager"
              :key="item.id"
              :label="
                (item.department_name ? '(' + item.department_name + ')' : '') +
                item.name
              "
              :value="item.id"
            />
            <template #footer>
              <el-button size="small" @click="onLoadAdmin()">刷新</el-button>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" style="grid-column: span 3">
          <el-input
            type="textarea"
            v-model="state.model.remark"
            :autosize="{ minRows: 2 }"
          ></el-input>
        </el-form-item>
      </div>
      <el-form-item label="">
        <div
          style="
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: flex-end;
          "
        >
          <el-button @click="onCancel" :disabled="!state.model.employee_num">
            取消
          </el-button>
          <el-button
            type="primary"
            @click="onSubmit"
            :disabled="!state.model.employee_num"
            >提交</el-button
          >
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import {
  payrollemployee_pay_detail,
  payrollemployee_pay_submit,
} from "@/http/payrollemployee";
import { ElMessage } from "element-plus";
import { admin_cascader } from "@/utils/qFormat";
import { data_settleunit_select } from "@/http/data";

export default {
  props: {
    payroll_id: Number,
    belonger_id: Number,
    belonger_department_id: Number,
    pay_date: String,
    ids: Array,
  },
  setup(props, { emit }) {
    const formDom = ref(null);
    const state = reactive({
      model: {},
      account_type: 1,
    });
    onMounted(() => {
      onLoadAdmin();

      payrollemployee_pay_detail({
        payroll_id: props.payroll_id,
        id: props.ids.join(","),
      }).then((res) => {
        if (res.status == 200) {
          state.model = res.data.data;
          state.model.payroll_id = props.payroll_id;
          state.model.id = props.ids.join(",");
          state.model.printer_id = props.belonger_id;
          state.model.printer_department_id = props.belonger_department_id;
          state.model.pay_date = props.pay_date;

          onLoadUnit();
        }
      });
    });

    //获取业务员
    const onLoadAdmin = () => {
      admin_cascader().then((res) => {
        state.admin_data = res;
      });
    };

    const onLoadUnit = () => {
      if (state.model.withholding_agent_type === 1) {
        data_settleunit_select(state.model.withholding_agent_id).then((res) => {
          if (res.status == 200) {
            state.settleunit_data = res.data.data?.list || [];
          }
        });
      }
    };

    const onUnitChange = (e) => {
      state.model.opening_bank = e.opening_bank;
      state.model.bank_account_name = e.bank_account_name;
      state.model.bank_account = e.bank_account;
    };

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          payrollemployee_pay_submit(state.model).then((res) => {
            if (res.status == 200) {
              ElMessage({
                message: res.data.msg,
                showClose: true,
                grouping: true,
                dangerouslyUseHTMLString: true,
                type: "success",
              });
              setTimeout(() => {
                emit("success", true);
              }, 500);
            }
          });
        }
      });
    };

    const onCancel = () => {
      emit("close");
    };
    return {
      state,
      props,
      formDom,
      onSubmit,
      onCancel,
      onLoadUnit,
      onUnitChange,
    };
  },
};
</script>
<style scoped lang="less"></style>
<style lang="less">
.payroll-pay-unit-select {
  .el-select-dropdown__item {
    height: auto;
    line-height: normal;
  }
}
</style>
